import fetch from "cross-fetch";

interface IResponse {
    data?: any;
    error?: string;
}

export namespace FetchUtility {
    export const TIME_OUT: string = "504 Gateway Time-out";
}

export class CustomError extends Error {
    data: any;

    constructor(message: string, data: any) {
        super(message);
        this.data = data;
        this.name = "CustomError";
    }
}

export function post<T>(url: string, data: any): Promise<T> {
    const cache: RequestCache = "no-cache";
    const credentials: RequestCredentials = "same-origin";

    const params = {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        //mode: "cors", // no-cors, cors, *same-origin
        cache: cache, // *default, no-cache, reload, force-cache, only-if-cached
        credentials: credentials, // include, *same-origin, omit
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            // "Content-Type": "application/x-www-form-urlencoded",
        },
        //redirect: "follow", // manual, *follow, error
        referrer: "no-referrer", // no-referrer, *client
        body: JSON.stringify(data), // body data type must match "Content-Type" header
    };

    return fetchWithParams(url, params);
}

export function get<T>(url: string): Promise<T> {
    const cache: RequestCache = "no-cache";
    const credentials: RequestCredentials = "same-origin";

    const params = {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        //mode: "cors", // no-cors, cors, *same-origin
        cache: cache, // *default, no-cache, reload, force-cache, only-if-cached
        credentials: credentials, // include, *same-origin, omit
        //redirect: "follow", // manual, *follow, error
        referrer: "no-referrer", // no-referrer, *client
        //body: JSON.stringify(data), // body data type must match "Content-Type" header
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    };

    return fetchWithParams(url, params);
}

function fetchWithParams(url: string, params) {
    return fetch(url, params)
        .then((response) => {
            if (!response.ok) {
                // extract content from error message and put it in a JSON object with error property;
                return new Promise<string>((resolve, reject) => {
                    return response.text().then((content) => {
                        try {
                            if (response.status == 302) {
                                const data = content ? JSON.parse(content) : {};

                                if (data.redirect) {
                                    window.location.href = data.redirect;
                                    return new Promise(() => {});
                                }
                            }

                            let error =
                                content || `Something went wrong. Status: ${response.status} ${response.statusText}`;

                            if (response.status == 504) {
                                error = FetchUtility.TIME_OUT;
                            }

                            const errorObj = { error: error, status: response.status, statusText: response.statusText };
                            const wrappedText = JSON.stringify(errorObj);
                            resolve(wrappedText);
                        } catch (e) {
                            reject(e);
                        }
                    });
                });
            }
            return response.text();
        })
        .then((data) => {
            return data ? JSON.parse(data) : {};
        })
        .then((data: IResponse) => {
            if (data.error) {
                throw new CustomError(data.error, data.data);
            }

            return data.data;
        });
}
